import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import PersonIcon from '@mui/icons-material/Person';
import MailIcon from '@mui/icons-material/Mail';
import {User} from "@lectra/react-authentication";

export const ProfileAuth0Data: React.FC<{user: User}> = ({user}) => {
    return (
        <List className="profileData">
            <NameListItem name={`${user.given_name}  ${user.family_name}`} />
            <MailListItem mail={user.email} />
            <PictureNicknameListItem nickname={user.nickname} picture={user.picture} />
        </List>
    );
};

const NameListItem: React.FC<{name: string}> = ({name}) => (
    <ListItem>
        <ListItemAvatar>
            <Avatar>
                <PersonIcon />
            </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Name" secondary={name}/>
    </ListItem>
);

const MailListItem: React.FC<{mail: string}> = ({mail}) => (
    <ListItem>
        <ListItemAvatar>
            <Avatar>
                <MailIcon />
            </Avatar>
        </ListItemAvatar>
        <ListItemText primary="Mail" secondary={mail}/>
    </ListItem>
);

const PictureNicknameListItem: React.FC<{nickname: string, picture: string}> = ({nickname, picture}) => (
    <ListItem>
        <ListItemAvatar>
            <Avatar src={picture} alt={nickname} />
        </ListItemAvatar>
        <ListItemText primary="Nickname" secondary={nickname}/>
    </ListItem>
);